import { Color } from 'components/colors';
import { Translate } from 'hooks/use-translation';

export const durationOptions = (translate: Translate<string>) =>
  [
    { label: translate('1_week'), value: 1 },
    { label: translate('2_weeks'), value: 2 },
    { label: translate('3_weeks'), value: 3 },
    { label: translate('4_weeks'), value: 4 },
    { label: translate('custom'), value: 0 },
  ] as const;

export const SPRINT_IN_TEMPLATE_DURATION_MULTIPLE = 5;

export const DEFAULT_STATUS = (translate: Translate<string>) => ({
  label: translate('todo'),
  group: 1,
  color: 'blue' as Color,
});
